import React from "react";
import Chip from "../Chip";
import { grey } from "@mui/material/colors";
import MUIAvatar from "@mui/material/Avatar";
import MarketingCampaign from "../../Utility/Crud/MarketingCampaign";

export default class ChipMarketingCampaign extends Chip {
  /**
   * Renders a MUI Avatar.
   */
  renderAvatar() {
    const color =
      this.props.marketingCampaign || this.props.hasSelection
        ? MarketingCampaign.getColor()
        : grey[500];
    const avatarColor = this.props.isTransparent ? "transparent" : color;
    const iconColor = this.props.isTransparent ? color : "#fff";

    return (
      <MUIAvatar sx={{ bgcolor: avatarColor }}>
        {MarketingCampaign.getIcon({
          fontSize: "small",
          sx: { color: iconColor },
        })}
      </MUIAvatar>
    );
  }

  /**
   * @return {string} The marketingCampaign name.
   */
  getLabel() {
    if (this.props.marketingCampaign) {
      return MarketingCampaign.getDisplayName(this.props.marketingCampaign);
    } else {
      return this.props.nullLabel || "None";
    }
  }
}
